/**
 * Formats an elapsed duration (in milliseconds) as a "m:ss" clock string,
 * clamping it to `[0, capMs]` first. Used by the play-time stopwatch shown
 * next to the "Moved" stat (see src/main.ts) — a purely informational,
 * capped-at-5-minutes counter with no effect on game rules, so it stays a
 * plain, independently testable formatting function here rather than living
 * in the pure game-rules core.
 */
export function formatElapsedTime(elapsedMs: number, capMs: number): string {
  const clamped = Math.max(0, Math.min(elapsedMs, capMs));
  const totalSeconds = Math.floor(clamped / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
